import React, { useState } from 'react';
import { observer } from 'mobx-react';
import classnames from "classnames";
import { UserModel } from "shared/models";
import { UiUserBadge } from "shared/uikit";
import { useNavigate, useStore } from "shared/hooks";
import { ROUTES } from "shared/constants";

import icon from './assets/icon.svg';
import arrow from './assets/arrow.svg';

import './styles.scss';

type PropsType = {
    user: UserModel,
    isProfile?: boolean
}

export const PProfileUnavailable = observer(({ user, isProfile }: PropsType) => {
    const store = useStore(() => ({
        isOpen: false,
    }));

    const navigate = useNavigate();
    if (user.isAvailable) {
        return null;
    }

    return (
        <div className={classnames('p-profile-unavailable', {'p-profile-unavailable--open': store.isOpen})} onClick={() => store.set("isOpen", !store.isOpen)}>
            <div className="p-profile-unavailable__header">
                <div className="p-profile-unavailable__icon" style={{ backgroundImage: `url(${icon})` }}/>
                <div className="p-profile-unavailable__group">
                    <div className="p-profile-unavailable__title">
                        {
                            isProfile ? "Вы не на рабочем месте"
                                : "Сотрудник отсутствует"
                        }
                    </div>

                    <div className="p-profile-unavailable__sign">
                        с {`${user.unavailableFromMoment.format('D MMMM YYYY')} до ${user.unavailableToMoment.format('D MMMM YYYY')}`}
                    </div>
                </div>
                <div className="p-profile-unavailable__arrow" style={{ backgroundImage: `url(${arrow})` }}></div>
            </div>
            {
                store.isOpen && (
                    <div className="p-profile-unavailable__body">
                        <div className="p-profile-unavailable-field">
                            <div className="p-profile-unavailable-field__name">Причина отстсутствия:</div>
                            <div className="p-profile-unavailable-field__value">{user.unavailableReason}</div>
                        </div>
                        {!!user.unavailableComment && (
                            <div className="p-profile-unavailable-field">
                                <div className="p-profile-unavailable-field__name">Комментарий:</div>
                                <div className="p-profile-unavailable-field__value">{user.unavailableComment}</div>
                            </div>
                        )}
                        {!!user.unavailableUser && (
                            <div className="p-profile-unavailable-field">
                                <div className="p-profile-unavailable-field__name">Замещающие сотрудник:</div>
                                <UiUserBadge
                                    value={user.unavailableUser}
                                    onClick={() => {
                                        if (user.unavailableUserId) {
                                            navigate(ROUTES.USER(user.unavailableUserId))
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </div>
                )
            }

        </div>
    );
});
